module.exports = __webpack_public_path__ + "static/media/drawBgm.e45ccd0b.mp3";